// src/main.js
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import request from "@/utils/request";
import api from "@/api"; // 导入 api 模块

// 挂载到原型
Vue.prototype.$REQ = request;
Vue.prototype.$api = api;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
